import * as tslib_1 from "tslib";
import * as React from "react";
import { Validator } from "pojo-validator";
/**
 * Hook that provides a validate method and its associated validationErrors as a state object managed by validation.
 *
 * validation is a callback that is working on a known model, with appropriate deps supplied.  This means it does not receive
 * a model to be checked as a passed in argument in the same way useValidator() does.
 *
 * @param validating the validation method.
 */
export function useValidatorCallback(validating, deps) {
    var _a = React.useState({}), validationErrors = _a[0], setValidationErrors = _a[1];
    // Create a ValidationCallback that ignores the model it receives and uses model that we get passed in as a dependency.
    var validatingModel = React.useCallback(function (model, validation, fieldsToCheck) {
        return validating(validation, fieldsToCheck);
    }, deps);
    // Create the method in the right format for us to return it so we can call validate() directly.
    var validate = React.useCallback(function (fieldsToCheck) {
        var validator = new Validator(validatingModel);
        // Work out the fields to be checked as we support passing a single field for convenience as well as passing an array.
        var fields = undefined;
        if (fieldsToCheck) {
            if (fieldsToCheck) {
                fields = [fieldsToCheck];
            }
            else {
                fields = fieldsToCheck;
            }
        }
        var ok = validator.validate({} /* Model is ignored by our validation code so we pass an empty object */, fields);
        setValidationErrors(tslib_1.__assign({}, validationErrors, validator.errors()));
        return ok;
    }, deps.concat([validatingModel, validationErrors, setValidationErrors]));
    return [validate, validationErrors];
}
//# sourceMappingURL=useValidatorCallback.js.map